import CompanyHeaderCard from "@/components/shared/AnonymousCompanyProfile/CompanyHeaderCard";
import AcceptInterestModal from "@/pages/interests/components/AcceptInterestModal";
import InterestActionConfirmModal from "@/pages/interests/components/InterestActionConfirmModal";
import {
  useWorkspacePartnerHeader,
  WORKSPACE_PARTNER_BOOKMARK_BTN_STYLES,
} from "@/pages/collaborations/components/useWorkspacePartnerHeader";

export type WorkspacePartnerCompanyHeaderProps = {
  company: any;
  collaboration: any | null;
  onCollaborationChange: (collaboration: any | null) => void;
  showShortlist?: boolean;
  onExpressInterestClick?: () => void;
  /** When the declined reconnect banner owns the CTA, hide duplicate Express Interest in the header. */
  hideInterestCTA?: boolean;
};

/** Compact partner header (GTID, anonymized contact, status chip, bookmark) for collaboration workspace. */
export default function WorkspacePartnerCompanyHeader({
  company,
  collaboration,
  onCollaborationChange,
  showShortlist = true,
  onExpressInterestClick,
  hideInterestCTA = false,
}: WorkspacePartnerCompanyHeaderProps) {
  const {
    userCompanyId,
    isFavorited,
    headquartersFlagEmoji,
    canIncomingReceiverDownloadAnonymizedPdf,
    anonymizedPdfLoading,
    declineLoading,
    acceptModalOpened,
    declineConfirmOpened,
    acceptLoading,
    openAcceptModal,
    closeAcceptModal,
    openDeclineConfirm,
    closeDeclineConfirm,
    handleShortlistClick,
    handleDownloadAnonymizedProfilePdf,
    handleAcceptConfirm,
    handleDeclineConfirm,
  } = useWorkspacePartnerHeader({ company, collaboration, onCollaborationChange });

  return (
    <>
      <CompanyHeaderCard
        company={company}
        headquartersFlagEmoji={headquartersFlagEmoji}
        showProfileVerificationStepper={false}
        hideInterestCTA={hideInterestCTA}
        disableShortlist={!showShortlist}
        isFavorited={isFavorited}
        collaborationStatus={collaboration}
        userCompanyId={userCompanyId}
        canIncomingReceiverDownloadAnonymizedPdf={canIncomingReceiverDownloadAnonymizedPdf}
        anonymizedPdfLoading={anonymizedPdfLoading}
        declineLoading={declineLoading}
        onExpressInterestClick={onExpressInterestClick ?? (() => undefined)}
        onShortlistClick={handleShortlistClick}
        onAcceptRequestClick={openAcceptModal}
        onDeclineClick={openDeclineConfirm}
        onDownloadAnonymizedProfilePdf={handleDownloadAnonymizedProfilePdf}
        bookmarkButtonStyles={WORKSPACE_PARTNER_BOOKMARK_BTN_STYLES}
        compactWorkspace
      />
      <AcceptInterestModal
        opened={acceptModalOpened}
        onClose={closeAcceptModal}
        onConfirm={handleAcceptConfirm}
        isLoading={acceptLoading}
      />
      <InterestActionConfirmModal
        opened={declineConfirmOpened}
        onClose={closeDeclineConfirm}
        onConfirm={() => void handleDeclineConfirm()}
        title="Reject collaboration request?"
        message="Do you want to reject this collaboration request?"
        confirmLabel="Yes, reject"
        confirmColor="red"
        isLoading={declineLoading}
      />
    </>
  );
}
